var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3681 2.81931V2.06769C14.3681 1.20673 13.6701 0.508789 12.8092 0.508789H1.67414C0.813178 0.508789 0.115234 1.20673 0.115234 2.06769V2.81931C0.115234 2.89617 0.177563 2.9585 0.254422 2.9585H14.2289C14.3057 2.9585 14.3681 2.89617 14.3681 2.81931Z",
    fill: "var(--green-800)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.115234 3.98831V8.74853C0.115234 9.60949 0.813178 10.3074 1.67414 10.3074H12.8092C13.6701 10.3074 14.3681 9.60949 14.3681 8.74853V3.98831C14.3681 3.91145 14.3057 3.84912 14.2289 3.84912H0.254422C0.177563 3.84912 0.115234 3.91145 0.115234 3.98831ZM3.67844 7.63503C3.67844 7.881 3.47902 8.08043 3.23304 8.08043H2.78764C2.54167 8.08043 2.34224 7.881 2.34224 7.63503V7.18963C2.34224 6.94366 2.54167 6.74423 2.78764 6.74423H3.23304C3.47902 6.74423 3.67844 6.94366 3.67844 7.18963V7.63503Z",
    fill: "var(--green-800)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayement);
export default __webpack_public_path__ + "static/media/payement.e94dd0f77951f677281863c3a12a2a01.svg";
export { ForwardRef as ReactComponent };